export const SignUp = {
    // 证件真伪检测 / document spoof detection
    SpoofDetection: '真伪检测',
    SpoofPass: '通过',
    SpoofRisk: '存在风险',
    SpoofTypeScreenRemark: '翻拍',
    SpoofTypePhotoCopy: '复印件',
    SpoofTypeTamper: 'PS篡改',
    SpoofTypeShortcut: '截屏',
    ParentIdDoc: '父亲或母亲的身份证明文件',
    HouseholdRegister: '户口本',
    ParentConsentStatement: '监护人同意书',
};
